import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiMenu, FiX, FiUser } from "react-icons/fi";
import "./Navbar.css";
import logo from "../../assets/newlogo.png";

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="navbar-left">
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="Company Logo" className="logo" />
        </Link>
      </div>

      {/* Links */}
      <div className="navbar-right">
        <div className="menu-icon" onClick={toggleMenu}>
          {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </div>

        <ul className={`nav-links ${menuOpen ? "show" : ""}`}>
  <li>
    <Link to="/" onClick={closeMenu} className={location.pathname === "/" ? "active" : ""}>
      Home
    </Link>
  </li>

  {/* <li>
    <Link to="/about" onClick={closeMenu} className={location.pathname === "/about" ? "active" : ""}>
      About
    </Link>
  </li> */}

  <li>
    <Link to="/services" onClick={closeMenu} className={location.pathname === "/services" ? "active" : ""}>
      Services
    </Link>
  </li>
{/* 
  <li>
    <Link to="/contact" onClick={closeMenu} className={location.pathname === "/contact" ? "active" : ""}>
      Contact
    </Link>
  </li> */}

  <li>
    <Link
      to="/verify-certificate"
      onClick={closeMenu}
      className={location.pathname === "/verify-certificate" ? "active" : ""}
    >
      Verify Certificate
    </Link>
  </li>
  <li>
  <Link
    to="/careers"
    onClick={closeMenu}
    className={location.pathname === "/careers" ? "active" : ""}
  >
    Careers
  </Link>
</li>


  {/* LOGIN BUTTON */}
  <li className="login-btn">
    <Link
      to="/login"
      onClick={closeMenu}
      className={location.pathname === "/login" ? "active" : ""}
    >
      <FiUser className="login-icon" />
      Login
    </Link>
  </li>
</ul>


      </div>
    </nav>
  );
};

export default Navbar;
